import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { reportTypeToCaption } from "../../../../../api/types/svTypes.ts";
import { getInvalidFieldsCount } from "../../../reporting/report-lists/reports/copyto/utils/getInvalidFieldsCount.ts";
import type { SelectedCompanyTile } from "../../hooks/validationStateSlice";

interface ReportValidatedProps {
  companyTile: SelectedCompanyTile;
}

export const ReportValidated = ({ companyTile }: ReportValidatedProps) => {
  const invalidFieldsCount = useMemo(() => getInvalidFieldsCount(companyTile.result), [companyTile.result]);

  return (
    <Grid container sx={{ gap: 0.8, flexWrap: "nowrap", alignItems: "center", width: "100%" }}>
      <Typography variant="caption" color="secondary">
        {companyTile.report?.reportType && reportTypeToCaption[companyTile.report?.reportType]}
      </Typography>
      <HorizontalFill />
      {invalidFieldsCount === 0 && (
        <>
          <Typography sx={{ color: "success.main" }}>All fields will be copied</Typography>
          <CheckRoundedIcon color="success" />
        </>
      )}
      {invalidFieldsCount > 0 && (
        <>
          <Typography sx={{ color: "warning.main" }}>
            {`${invalidFieldsCount} field${invalidFieldsCount > 1 ? "s" : ""} can't be copied`}
          </Typography>
          <WarningRoundedIcon color="warning" />
        </>
      )}
    </Grid>
  );
};
